import auth from '../auth';
import ApigClientFactory from '../apigClient';
import * as _ from "lodash";

export const OfferService = {
    async query(roles) {
        const possibleRoles = _.intersectionBy(roles, [process.env.RTPS_ROLE_DATA_ADMIN, process.env.RTPS_ROLE_APPROVER]);
        const role = _.head(possibleRoles);
        if (!role) {
            throw new Error("User does not have access to the require role.");
        }
        const client = await this.getClient(role);
        return client.invokeApi({}, '/offer', 'GET', {});
    },

    async get(copayOfferId, returnActive, roles) {
        const possibleRoles = _.intersectionBy(roles, [process.env.RTPS_ROLE_DATA_ADMIN, process.env.RTPS_ROLE_APPROVER]);
        let activePath = "";
        if (returnActive) {
            activePath = "/true";
        }
        const role = _.head(possibleRoles);
        if (!role) {
            throw new Error("User does not have access to the require role.");
        }
        const client = await this.getClient(role);
        return client.invokeApi({}, '/offer/' + copayOfferId + activePath, 'GET', {});
    },

    async add(offer) {
        const client = await this.getClient(process.env.RTPS_ROLE_DATA_ADMIN);
        return client.invokeApi({}, '/offer', 'POST', {}, offer);
    },

    async save(offer) {
        const client = await this.getClient(process.env.RTPS_ROLE_DATA_ADMIN);
        return client.invokeApi({}, '/offer/' + offer.copay_offer_id, 'PUT', {}, offer);
    },

    async requestApproval(offer) {
        const client = await this.getClient(process.env.RTPS_ROLE_DATA_ADMIN);
        return client.invokeApi({}, '/offer/' + offer.copay_offer_id + '/request-approval', 'POST', {}, offer);
    },

    async approve(offer) {
        const client = await this.getClient(process.env.RTPS_ROLE_APPROVER);
        return client.invokeApi({}, '/offer/' + offer.copay_offer_id + '/approve', 'POST', {}, offer);
    },

    async publish(offer) {
        const client = await this.getClient(process.env.RTPS_ROLE_APPROVER);
        return client.invokeApi({}, '/offer/' + offer.copay_offer_id + '/publish', 'POST', {}, offer);
    },

    async cancelUpdate(offer) {
        const client = await this.getClient(process.env.RTPS_ROLE_DATA_ADMIN);
        return client.invokeApi({}, '/offer/' + offer.copay_offer_id + '/cancel-update', 'POST', {}, offer);
    },

    async getGlobalProductLists(roles) {
        const possibleRoles = _.intersectionBy(roles, [process.env.RTPS_ROLE_DATA_ADMIN, process.env.RTPS_ROLE_APPROVER]);
        const role = _.head(possibleRoles);

        if (!role) {
            throw new Error('User does not have access to the require role.');
        }

        const client = await this.getClient(role);
        return client.invokeApi({}, '/global-product-lists', 'GET', {});
    },

    async getConfig(role) {
        let config = {
            invokeUrl: process.env.RTPS_ADMIN_API_URL,
            region: process.env.AWS_REGION,
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };

        await auth.getCredentialsForRole(role)
            .then((credentials) => {
                config.accessKey = credentials.Credentials.AccessKeyId;
                config.secretKey = credentials.Credentials.SecretKey;
                config.sessionToken = credentials.Credentials.SessionToken;
            });
        return config;
    },

    async getClient(role) {
        const config = await this.getConfig(role);
        return ApigClientFactory.newClient(config);
    }
};



// WEBPACK FOOTER //
// ./src/services/rtps/offer.service.js